import { z } from "zod";

export const BDNB_COORDINATE = z.tuple([z.number(), z.number()]);

export type BdnbCoordinate = z.infer<typeof BDNB_COORDINATE>;

export const BDNB_GEOM_GROUP = z.object({
  type: z.string(),
  coordinates: z.array(z.array(z.array(BDNB_COORDINATE))),
});

export type BdnbGeomGroup = z.infer<typeof BDNB_GEOM_GROUP>;

export const BDNB_API_RESPONSE_SCHEMA = z.object({
  cle_interop_adr: z.string().nullish(),
  batiment_groupe_id: z.string().nullish(),
  lien_valide: z.boolean().nullish(),
  code_departement_insee: z.string().nullish(),
  code_commune_insee: z.string().nullish(),
  commune_parente: z.string().nullish(),
  code_epci_insee: z.string().nullish(),
  code_iris: z.string().nullish(),
  libelle_commune_insee: z.string().nullish(),
  code_region_insee: z.string().nullish(),
  s_geom_groupe: z.number().nullish(),
  l_parcelle_id: z.array(z.string()).nullish(),
  l_cle_interop_adr: z.array(z.string()).nullish(),
  l_libelle_adr: z.array(z.string()).nullish(),
  l_siren: z.array(z.string()).nullish(),
  l_denomination_proprietaire: z.array(z.string()).nullish(),
  code_qp: z.string().nullish(),
  nom_qp: z.string().nullish(),
  quartier_prioritaire: z.boolean().nullish(),
  libelle_adr_principale_ban: z.string().nullish(),
  nb_adresse_valid_ban: z.number().nullish(),
  cle_interop_adr_principale_ban: z.string().nullish(),
  conso_pro_dle_elec_2020: z.number().nullish(),
  conso_res_dle_elec_2020: z.number().nullish(),
  conso_pro_dle_gaz_2020: z.number().nullish(),
  conso_res_dle_gaz_2020: z.number().nullish(),
  nb_pdl_pro_dle_gaz_2020: z.number().nullish(),
  nb_pdl_res_dle_gaz_2020: z.number().nullish(),
  nb_pdl_pro_dle_elec_2020: z.number().nullish(),
  nb_pdl_res_dle_elec_2020: z.number().nullish(),
  nb_classe_bilan_dpe_a: z.number().nullish(),
  nb_classe_bilan_dpe_b: z.number().nullish(),
  nb_classe_bilan_dpe_c: z.number().nullish(),
  nb_classe_bilan_dpe_d: z.number().nullish(),
  nb_classe_bilan_dpe_e: z.number().nullish(),
  nb_classe_bilan_dpe_f: z.number().nullish(),
  nb_classe_bilan_dpe_g: z.number().nullish(),
  nb_classe_conso_energie_arrete_2012_a: z.number().nullish(),
  nb_classe_conso_energie_arrete_2012_b: z.number().nullish(),
  nb_classe_conso_energie_arrete_2012_c: z.number().nullish(),
  nb_classe_conso_energie_arrete_2012_d: z.number().nullish(),
  nb_classe_conso_energie_arrete_2012_e: z.number().nullish(),
  nb_classe_conso_energie_arrete_2012_f: z.number().nullish(),
  nb_classe_conso_energie_arrete_2012_g: z.number().nullish(),
  nb_classe_conso_energie_arrete_2012_nc: z.number().nullish(),
  identifiant_dpe: z.string().nullish(),
  arrete_2021: z.boolean().nullish(),
  date_reception_dpe: z.string().nullish(),
  type_dpe: z.string().nullish(),
  classe_bilan_dpe: z.string().nullish(),
  classe_conso_energie_arrete_2012: z.string().nullish(),
  conso_5_usages_ep_m2: z.number().nullish(),
  emission_ges_5_usages_m2: z.number().nullish(),
  conso_3_usages_ep_m2_arrete_2012: z.number().nullish(),
  emission_ges_3_usages_ep_m2_arrete_2012: z.number().nullish(),
  type_vitrage: z.string().nullish(),
  type_materiaux_menuiserie: z.string().nullish(),
  type_gaz_lame: z.string().nullish(),
  type_fermeture: z.string().nullish(),
  vitrage_vir: z.boolean().nullish(),
  epaisseur_lame: z.number().nullish(),
  u_baie_vitree: z.number().nullish(),
  facteur_solaire_baie_vitree: z.number().nullish(),
  l_orientation_baie_vitree: z.array(z.string()).nullish(),
  pourcentage_surface_baie_vitree_exterieur: z.number().nullish(),
  traversant: z.string().nullish(),
  presence_balcon: z.boolean().nullish(),
  u_mur_exterieur: z.number().nullish(),
  type_isolation_mur_exterieur: z.string().nullish(),
  materiaux_structure_mur_exterieur: z.string().nullish(),
  type_isolation_plancher_bas: z.string().nullish(),
  type_plancher_bas_deperditif: z.string().nullish(),
  u_plancher_bas_final_deperditif: z.number().nullish(),
  type_isolation_plancher_haut: z.string().nullish(),
  type_plancher_haut_deperditif: z.string().nullish(),
  u_plancher_haut_deperditif: z.number().nullish(),
  classe_inertie: z.string().nullish(),
  type_installation_chauffage: z.string().nullish(),
  type_energie_chauffage: z.string().nullish(),
  type_generateur_chauffage: z.string().nullish(),
  type_generateur_chauffage_anciennete: z.string().nullish(),
  type_energie_chauffage_appoint: z.string().nullish(),
  type_generateur_chauffage_appoint: z.string().nullish(),
  type_generateur_chauffage_anciennete_appoint: z.string().nullish(),
  chauffage_solaire: z.boolean().nullish(),
  type_generateur_climatisation: z.string().nullish(),
  type_generateur_climatisation_anciennete: z.string().nullish(),
  type_installation_ecs: z.string().nullish(),
  type_generateur_ecs: z.string().nullish(),
  type_generateur_ecs_anciennete: z.string().nullish(),
  ecs_solaire: z.boolean().nullish(),
  type_ventilation: z.string().nullish(),
  type_production_energie_renouvelable: z.string().nullish(),
  annee_construction: z.number().nullish(),
  nb_log: z.number().nullish(),
  nb_niveau: z.number().nullish(),
  surface_emprise_sol: z.number().nullish(),
  usage_niveau_1_txt: z.string().nullish(),
  mat_mur_txt: z.string().nullish(),
  mat_toit_txt: z.string().nullish(),
  contient_fictive_geom_groupe: z.boolean().nullish(),
  geom_groupe: BDNB_GEOM_GROUP.nullish(),
  hauteur_mean: z.number().nullish(),
  altitude_sol_mean: z.number().nullish(),
  alea_argiles: z.string().nullish(),
  alea_radon: z.string().nullish(),
  nb_log_rnc: z.number().nullish(),
  nb_lot_garpark_rnc: z.number().nullish(),
  nb_lot_tertiaire_rnc: z.number().nullish(),
  numero_immat_principal: z.string().nullish(),
  distance_batiment_historique_plus_proche: z.number().nullish(),
  nom_batiment_historique_plus_proche: z.string().nullish(),
  perimetre_bat_historique: z.boolean().nullish(),
  nom_quartier_qpv: z.string().nullish(),
  fiabilite_cr_adr_niv_2: z.string().nullish(),
  fiabilite_cr_adr_niv_1: z.string().nullish(),
  fiabilite_emprise_sol: z.string().nullish(),
  fiabilite_hauteur: z.string().nullish(),
  croisement_geospx_reussi: z.union([z.boolean(), z.string()]).nullish(),
  uw: z.number().nullish(),
  nb_installation_chauffage: z.number().nullish(),
  nb_installation_ecs: z.number().nullish(),
  type_generateur_ecs_appoint: z.string().nullish(),
  type_generateur_ecs_anciennete_appoint: z.string().nullish(),
  annee_construction_dpe: z.number().nullish(),
  type_batiment_dpe: z.string().nullish(),
  id_reseau: z.string().nullish(),
  indicateur_distance_au_reseau: z.string().nullish(),
});

export type BdnbApiResponse = z.infer<typeof BDNB_API_RESPONSE_SCHEMA>;
